export default __webpack_public_path__ + "static/media/GHSI Regular Board Minutes 16 February.274c9cdc.pdf";